import { apiClient } from './client';

// Lead Tracker — lead lifecycle + KPI API client (NOT a CRM).
const BASE = '/lead-tracker';

export const getLeadOptions = () => apiClient.get(`${BASE}/options`);
export const getLeadOwners = () => apiClient.get(`${BASE}/owners`);
export const getLeadSettings = () => apiClient.get(`${BASE}/settings`);
export const saveLeadSettings = (payload) => apiClient.put(`${BASE}/settings`, payload);

export const getLeadKpis = (params) => apiClient.get(`${BASE}/kpis`, { params });
export const getLeadSummary = () => apiClient.get(`${BASE}/summary`);

export const listLeads = (params) => apiClient.get(`${BASE}/leads`, { params });
export const createLead = (payload) => apiClient.post(`${BASE}/leads`, payload);
export const updateLead = (id, payload) => apiClient.patch(`${BASE}/leads/${id}`, payload);
export const setLeadStage = (id, payload) => apiClient.post(`${BASE}/leads/${id}/stage`, payload);
export const deleteLead = (id) => apiClient.delete(`${BASE}/leads/${id}`);
export const bulkDeleteLeads = (ids) => apiClient.post(`${BASE}/leads/bulk-delete`, { ids });
export const mergeLeads = (primaryId, mergeIds) =>
  apiClient.post(`${BASE}/leads/merge`, { primary_id: primaryId, merge_ids: mergeIds });
export const getDuplicateLeads = () => apiClient.get(`${BASE}/leads-duplicates`);


// GoHighLevel historical backfill
export const previewGhlImport = (payload) => apiClient.post(`${BASE}/ghl-import/preview`, payload);
export const startGhlImport = (payload) => apiClient.post(`${BASE}/ghl-import`, payload);
export const getGhlImportJob = (id) => apiClient.get(`${BASE}/ghl-import/${id}`);
export const pushLeadToAspire = (id) => apiClient.post(`${BASE}/leads/${id}/push-aspire`, {});
export const getLead = (id) => apiClient.get(`${BASE}/leads/${id}`);
export const getLeadActivity = (id) => apiClient.get(`${BASE}/leads/${id}/activity`);
export const checkGhlToken = () => apiClient.get(`${BASE}/ghl-import/check`);
export const getAspireLeadOptions = (refresh) =>
  apiClient.get(`${BASE}/aspire-options`, { params: refresh ? { refresh: 1 } : {} });

// Follow-ups
export const logTouch = (id, payload) => apiClient.post(`${BASE}/leads/${id}/touch`, payload);
export const getFollowups = (params) => apiClient.get(`${BASE}/followups`, { params });
export const pauseFollowup = (id, paused) =>
  apiClient.post(`${BASE}/leads/${id}/followup-pause`, { paused });
export const markConsultDone = (id, done = true) =>
  apiClient.post(`${BASE}/leads/${id}/consult-done`, { done });

// Google Calendar — push/remove a lead's appointment
export const pushLeadToCalendar = (id, payload) =>
  apiClient.post(`${BASE}/leads/${id}/calendar-event`, payload || {});
export const removeLeadFromCalendar = (id) =>
  apiClient.delete(`${BASE}/leads/${id}/calendar-event`);

export const getLatestGhlImport = () => apiClient.get(`${BASE}/ghl-import/latest`);
export const getGhlPipelines = (refresh) =>
  apiClient.get(`${BASE}/ghl-import/pipelines`, { params: refresh ? { refresh: 1 } : {} });
export const recheckGhlPipelines = (dryRun) =>
  apiClient.post(`${BASE}/ghl-import/recheck`, { dry_run: !!dryRun });

// HubSpot historical backfill — same shape as GoHighLevel above; a company runs
// one CRM at a time, so only one set of these is ever used.
export const previewHubspotImport = (payload) => apiClient.post(`${BASE}/hubspot-import/preview`, payload);
// Runs the automatic HubSpot sync now (waits ~40s, then {status: 'running'} while it finishes).
export const pullHubspotRecent = () => apiClient.post(`${BASE}/hubspot-refresh`);
export const getHubspotSyncStatus = () => apiClient.get(`${BASE}/hubspot-sync`);
export const setHubspotSyncEnabled = (enabled) => apiClient.patch(`${BASE}/hubspot-sync`, { enabled });
export const setHubspotOldContacts = (enabled, since) =>
  apiClient.patch(`${BASE}/hubspot-sync/old-contacts`, { enabled, since: enabled ? since : null });
export const startHubspotImport = (payload) => apiClient.post(`${BASE}/hubspot-import`, payload);
export const getHubspotImportJob = (id) => apiClient.get(`${BASE}/hubspot-import/${id}`);
export const getLatestHubspotImport = () => apiClient.get(`${BASE}/hubspot-import/latest`);
export const checkHubspotToken = () => apiClient.get(`${BASE}/hubspot-import/check`);
export const getHubspotPipelines = (refresh) =>
  apiClient.get(`${BASE}/hubspot-import/pipelines`, { params: refresh ? { refresh: 1 } : {} });
export const recheckHubspotPipelines = (dryRun) =>
  apiClient.post(`${BASE}/hubspot-import/recheck`, { dry_run: !!dryRun });
// Reads their newest deals to work out which pipelines actually hold leads.
export const getHubspotPipelineAdvice = (refresh) =>
  apiClient.get(`${BASE}/hubspot-import/pipeline-advice`, { params: refresh ? { refresh: 1 } : {} });
